import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';

const Masterpiece: React.FC = () => {
    const { t } = useLang('Masterpiece');

    return (
        <section
            className={`${css.Masterpiece} GtmModuleData-section`}
            id="stream-ultra-x-Masterpiece"
            data-section-id={'stream-ultra-x-Masterpiece'}
            data-section-title={t('title')}
        >
            <div className="sticky">
                <div className="box1 box">
                    <div className="info">
                        <p className="title">{t('title')}</p>
                        <p className="desc">{t('desc')}</p>
                    </div>
                    <div className="inner">
                        <EcoImg
                            className="img"
                            pc={
                                'https://websiteoss.ecoflow.com/figma-uploads/1756197502393-roknfe-compressed-%E6%9C%A8%E7%BA%B9%E9%A5%B0%E6%9D%BF%E5%9C%BA%E6%99%AF%E5%9B%BE%201.jpg'
                            }
                            h5={'https://websiteoss.ecoflow.com/figma-uploads/1756197525712-6z697u-compressed-%E6%9C%A8%E7%BA%B9%E9%9D%A2%E6%9D%BF.jpg'}
                            alt={t('item1_title')}
                            isOpenLazy={true}
                        />
                        <div className="item-info">
                            <p className="info-title">{t('item1_title')}</p>
                            <p className="info-desc">{t('item1_desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="box2 box">
                <div className="info">
                    <p className="title">{t('title')}</p>
                    <p className="desc">{t('desc')}</p>
                </div>
                <div className="inner">
                    <EcoImg
                        className="img"
                        pc={'https://websiteoss.ecoflow.com/upload/image/1754017365937/21_2.jpg'}
                        h5={'https://websiteoss.ecoflow.com/upload/image/1754017366888/21_2_M.jpg'}
                        alt={t('item1_title')}
                        isOpenLazy={true}
                    />
                    <div className="item-info">
                        <p className="info-title">{t('item2_title')}</p>
                        <p className="info-desc">{t('item2_desc')}</p>
                    </div>
                </div>
            </div> */}
        </section>
    );
};

export default Masterpiece;
